<template>
    <div
        class="locations-radio"
    >
        <input
            type="checkbox"
            :id="inputId"
            v-model="model"
            :value="value"
        />
        <label :for="inputId">
            <slot name="default"/>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
        },
        value: {
            type: Object,
        },
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            }
        },

        inputId() {
            return 'check-' + Math.random().toString(36).substring(2, 9);
        },
    },
};
</script>